// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"f57e137f","453":"72438b16"}[chunkId] + ".chunk.js";
};